export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    mstItemList: [
      {
        optClasCd: "SOP00004",
        optItemCd: "00000255",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 1,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "케냐AA 니에리 워시드",
        presetNmKo: "케냐AA 니에리 워시드",
        presetNmEn: "케냐AA 니에리 워시드",
        presetNmJp: "케냐AA 니에리 워시드",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 500,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00005",
        optItemCd: "00000266",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 1,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "자메이카 블루마운틴",
        presetNmKo: "자메이카 블루마운틴",
        presetNmEn: "자메이카 블루마운틴",
        presetNmJp: "자메이카 블루마운틴",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 1000,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00004",
        optItemCd: "00000256",
        optItemType: "0",
        optItemUseType: "A",
        optItemOrder: 2,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "케냐AA 니에리 워시드2",
        presetNmKo: "케냐AA 니에리 워시드2",
        presetNmEn: "케냐AA 니에리 워시드2",
        presetNmJp: "케냐AA 니에리 워시드2",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 400,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00005",
        optItemCd: "00000267",
        optItemType: "0",
        optItemUseType: "A",
        optItemOrder: 2,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "자메이카 블루마운틴2",
        presetNmKo: "자메이카 블루마운틴2",
        presetNmEn: "자메이카 블루마운틴2",
        presetNmJp: "자메이카 블루마운틴2",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 900,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00004",
        optItemCd: "00000257",
        optItemType: "0",
        optItemUseType: "A",
        optItemOrder: 3,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "케냐AA 니에리 워시드3",
        presetNmKo: "케냐AA 니에리 워시드3",
        presetNmEn: "케냐AA 니에리 워시드3",
        presetNmJp: "케냐AA 니에리 워시드3",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 300,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00005",
        optItemCd: "00000268",
        optItemType: "0",
        optItemUseType: "A",
        optItemOrder: 3,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "자메이카 블루마운틴3",
        presetNmKo: "자메이카 블루마운틴3",
        presetNmEn: "자메이카 블루마운틴3",
        presetNmJp: "자메이카 블루마운틴3",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 800,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00004",
        optItemCd: "00000258",
        optItemType: "0",
        optItemUseType: "A",
        optItemOrder: 4,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "케냐AA 니에리 워시드4",
        presetNmKo: "케냐AA 니에리 워시드4",
        presetNmEn: "케냐AA 니에리 워시드4",
        presetNmJp: "케냐AA 니에리 워시드4",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 200,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00005",
        optItemCd: "00000269",
        optItemType: "0",
        optItemUseType: "A",
        optItemOrder: 4,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "자메이카 블루마운틴4",
        presetNmKo: "자메이카 블루마운틴4",
        presetNmEn: "자메이카 블루마운틴4",
        presetNmJp: "자메이카 블루마운틴4",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 700,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00001",
        optItemCd: "00000150",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122375278",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375278_1_v0001. Mammoth Gourmet Butter Plain Scone.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375278_1_v0001. Mammoth Gourmet Butter Plain Scone.png",
        salesQty: 0,
        presetNm: "매머드 고메버터 플레인 스콘",
        presetNmKo: "매머드 고메버터 플레인 스콘",
        presetNmEn: "Mammoth Gourmet Butter Plain Scone ",
        presetNmJp: "Mammoth Gourmet Butter Plain Scone ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 500,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00001",
        optItemCd: "00000151",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122375279",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375279_1_v0001. Mammoth Gourmet Butter Chocolate Scone.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375279_1_v0001. Mammoth Gourmet Butter Chocolate Scone.png",
        salesQty: 0,
        presetNm: "매머드 고메버터 초코 스콘 ",
        presetNmKo: "매머드 고메버터 초코 스콘 ",
        presetNmEn: "Mammoth Gourmet Butter Chocolate Scone",
        presetNmJp: "Mammoth Gourmet Butter Chocolate Scone",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 500,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00001",
        optItemCd: "00000152",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122375280",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375280_1_v0001. Mammoth Chocolate Pound Cake.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375280_1_v0001. Mammoth Chocolate Pound Cake.png",
        salesQty: 0,
        presetNm: "매머드 초코 파운드 케이크",
        presetNmKo: "매머드 초코 파운드 케이크",
        presetNmEn: "Mammoth Chocolate Pound Cake",
        presetNmJp: "Mammoth Chocolate Pound Cake",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 500,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00001",
        optItemCd: "00000153",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122375281",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375281_1_v0001. Mammoth Lemon Pound Cake.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375281_1_v0001. Mammoth Lemon Pound Cake.png",
        salesQty: 0,
        presetNm: "매머드 레몬 파운드 케이크",
        presetNmKo: "매머드 레몬 파운드 케이크",
        presetNmEn: "Mammoth Lemon Pound Cake",
        presetNmJp: "Mammoth Lemon Pound Cake",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 500,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00001",
        optItemCd: "00000154",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122375282",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375282_1_v0001. Mammoth Meat Chili Hot Dog.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375282_1_v0001. Mammoth Meat Chili Hot Dog.png",
        salesQty: 0,
        presetNm: "매머드 미트 칠리 핫도그",
        presetNmKo: "매머드 미트 칠리 핫도그",
        presetNmEn: "Mammoth Meat Chili Hot Dog",
        presetNmJp: "Mammoth Meat Chili Hot Dog",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 500,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00001",
        optItemCd: "00000155",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122375283",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375283_1_v0001. Mammoth Relish Hot Dog.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375283_1_v0001. Mammoth Relish Hot Dog.png",
        salesQty: 0,
        presetNm: "매머드 렐리시 핫도그",
        presetNmKo: "매머드 렐리시 핫도그",
        presetNmEn: "Mammoth Relish Hot Dog",
        presetNmJp: "Mammoth Relish Hot Dog",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 500,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00001",
        optItemCd: "00000156",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122375284",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/option/0801/2122375284_1_v0004.jpg",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375284_1_v0002.jpg",
        salesQty: 0,
        presetNm: "폭탄 카스테라",
        presetNmKo: "폭탄 카스테라",
        presetNmEn: "Bomb Castela",
        presetNmJp: "Bomb Castela",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 500,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00001",
        optItemCd: "00000157",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122375285",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375285_1_v0001. Milk Crepe.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122375285_1_v0002. Milk Crepe_white.png",
        salesQty: 0,
        presetNm: "밀크 크레이프",
        presetNmKo: "밀크 크레이프",
        presetNmEn: "Milk Crepe",
        presetNmJp: "Milk Crepe",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 500,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "00000147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "S 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: -300,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "00000148",
        optItemType: "0",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "M 사이즈 ",
        presetNmKo: "M 사이즈 ",
        presetNmEn: "M",
        presetNmJp: "Mサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 100,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "00000149",
        optItemType: "0",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "L 사이즈",
        presetNmKo: "L 사이즈",
        presetNmEn: "L",
        presetNmJp: "Lサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 200,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00006",
        optItemCd: "00000259",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122376081",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376081_1_v0001.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376081_1_v0001.png",
        salesQty: 0,
        presetNm: "매장컵",
        presetNmKo: "매장컵",
        presetNmEn: "매장컵",
        presetNmJp: "매장컵",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 0,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00006",
        optItemCd: "00000260",
        optItemType: "0",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122376082",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376082_1_v0001.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376082_1_v0001.png",
        salesQty: 0,
        presetNm: "일회용컵",
        presetNmKo: "일회용컵",
        presetNmEn: "일회용컵",
        presetNmJp: "일회용컵",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 100,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00006",
        optItemCd: "00000261",
        optItemType: "0",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122376083",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376083_1_v0001.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376083_1_v0001.png",
        salesQty: 0,
        presetNm: "개인컵",
        presetNmKo: "개인컵",
        presetNmEn: "개인컵",
        presetNmJp: "개인컵",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 0,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00007",
        optItemCd: "00000262",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122376084",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376084_1_v0001.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376084_1_v0001.png",
        salesQty: 0,
        presetNm: "휘핑크림",
        presetNmKo: "휘핑크림",
        presetNmEn: "휘핑크림",
        presetNmJp: "휘핑크림",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 300,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00007",
        optItemCd: "00000263",
        optItemType: "0",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122376085",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376085_1_v0001.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376085_1_v0001.png",
        salesQty: 0,
        presetNm: "초코칩",
        presetNmKo: "초코칩",
        presetNmEn: "초코칩",
        presetNmJp: "초코칩",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 400,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00007",
        optItemCd: "00000264",
        optItemType: "0",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122376086",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376086_1_v0001.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376086_1_v0001.png",
        salesQty: 0,
        presetNm: "달고나",
        presetNmKo: "달고나",
        presetNmEn: "달고나",
        presetNmJp: "달고나",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 200,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "SOP00007",
        optItemCd: "00000265",
        optItemType: "0",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "2122376087",
        optItemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376087_1_v0001.png",
        itemImgFileUrl:
          "https://cloudposofficedevo.shinsegae.com/img/item/0801/2122376087_1_v0001.png",
        salesQty: 0,
        presetNm: "인절미 그래놀라",
        presetNmKo: "인절미 그래놀라",
        presetNmEn: "인절미 그래놀라",
        presetNmJp: "인절미 그래놀라",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "001",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 900,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 100,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "10000147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "XL 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 3000,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "20000147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "XXL 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 30000,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "30000147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "XXXL 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 300000,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "40000147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "XXXXL 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 3000000,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "50000147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "XXXXXL 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 30000000,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "60000147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "XXXXXXL 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 300000000,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "70000147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "XXXXXXL 사이즈같은 L사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 200,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "80000147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "XXXXXXL 사이즈같은 M사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 200,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "90000147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "랜덤 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 30000,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "00001147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "S 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: -300,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "00002147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "S 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: -300,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "00003147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "S 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: -300,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "00004147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "S 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: -300,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "00005147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "S 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: -300,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00002",
        optItemCd: "00006147",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "S 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: -300,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },

      {
        optClasCd: "OPT00009",
        optItemCd: "00009996",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "선택안함",
        presetNmKo: "선택안함",
        presetNmEn: "선택안함",
        presetNmJp: "선택안함",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 0,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00009",
        optItemCd: "00009997",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "S 사이즈",
        presetNmKo: "S 사이즈",
        presetNmEn: "S",
        presetNmJp: "Sサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: -300,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00009",
        optItemCd: "00009998",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "M 사이즈",
        presetNmKo: "M 사이즈",
        presetNmEn: "M",
        presetNmJp: "Mサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 0,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
      {
        optClasCd: "OPT00009",
        optItemCd: "00009999",
        optItemType: "1",
        optItemUseType: "A",
        optItemOrder: 999,
        optItemImgFileId: "",
        optItemImgFileUrl: "",
        itemImgFileUrl: "",
        salesQty: 0,
        presetNm: "L 사이즈",
        presetNmKo: "L 사이즈",
        presetNmEn: "L",
        presetNmJp: "Lサイズ",
        presetNmCn: "",
        presetNmTw: "",
        clasLCd: "002",
        clasMCd: "001",
        clasSCd: "001",
        saleUprc: 300,
        svcRate: 0,
        taxFlgCd: "1",
        taxRdcFlgCd: "1",
        supyUprc: 0,
        mgRate: 0,
        dcAbleYn: "Y",
        evntNm: null,
        evntKindCd: null,
        evntFromDate: null,
        evntEndDate: null,
        evntFlgCd: null,
        timeSaleYn: null,
        timeSaleFromTime: null,
        timeSaleEndTime: null,
        evntCd: null,
        evntItemCd: null,
        evntDcFlgCd: null,
        evntDcAmt: null,
      },
    ],
  },
};
